export const SlideData = [
      // {
      //   img:"https://rukminim1.flixcart.com/image/416/416/knyxqq80/dslr-camera/r/y/x/digital-camera-eos-m50-mark-ii-eos-m50-mark-ii-canon-original-imag2gzkexzqhyhu.jpeg?q=70",
      //   name:"Blankets",
      //   offer:"Min. 50% Off"
      // },
      {
        img:"https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/c6346cd58d79b988.jpg?q=50",
        name:"Blankets",
        offer:"Min. 50% Off"
      },
      {
        img:"https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/6137ec1c2dead906.jpg?q=50",
        name:"Blankets",
        offer:"Min. 50% Off"
      },
      {
        img:"https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/c6346cd58d79b988.jpg?q=50",
        name:"Blankets",
        offer:"Min. 50% Off"
      },
      {
        img:"https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/6137ec1c2dead906.jpg?q=50",
        name:"Blankets",
        offer:"Min. 50% Off"
      },
      {
        img:"https://rukminim1.flixcart.com/flap/1688/280/image/ff938f15fd1feb73.jpg?q=50",
        name:"Blankets",
        offer:"Min. 50% Off"
      },
      {
        img:"https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/c6346cd58d79b988.jpg?q=50",
        name:"Blankets",
        offer:"Min. 50% Off"
      },
      {
        img:"https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/6137ec1c2dead906.jpg?q=50",
        name:"Blankets",
        offer:"Min. 50% Off"
      },
      {
        img:"https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/c6346cd58d79b988.jpg?q=50",
        name:"Blankets",
        offer:"Min. 50% Off"
      },
      {
        img:"https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/6137ec1c2dead906.jpg?q=50",
        name:"Blankets",
        offer:"Min. 50% Off"
      },
      {
        img:"https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/c6346cd58d79b988.jpg?q=50",
        name:"Blankets",
        offer:"Min. 50% Off"
      },
      {
        img:"https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/6137ec1c2dead906.jpg?q=50",
        name:"Blankets",
        offer:"Min. 50% Off"
      },
      
]